<template>
<div>
  <div style="height:60px" class="hidden-md-and-up"></div>
  <h2>Juramentos</h2>
  <v-layout row wrap>
    <v-flex lg8 md8 sm6 xs12 order-xs3 order-md2>
      <v-card>
        <v-toolbar color="default"  class="title font-weight-bold  elevation-0">
          Lista de Juramentos - Gestion {{ new Date().getFullYear() }}
        </v-toolbar>
        <v-card-text>
          <v-text-field
            class="px-5"
            v-model="search"
            append-icon="search"
            label="Busqueda por Departamento o lugar del Juramento"
            clearable
            hide-details
          ></v-text-field>
          <v-data-table
            :headers="headers"
            :items="desserts"
            :pagination.sync="pagination"
            :search="search"
            hide-actions
            no-results-text="Sin resultados, no se encuentra ningun registro"
          >
            <template slot="items" slot-scope="props">
              <Registro :juramento="props.item" @mostrarFotos="verFotosJuramento"/>
            </template>
            <template slot="no-data">No se encontraron Registros de Juramentos para esta Gestion</template>
            <template slot="no-results">
              Sin resultados para la busqueda
              <strong>" {{search}} "</strong>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-flex>
    <v-flex lg4 md4 sm6 xs12 order-xs2 order-md3>
      <v-card>
        <v-toolbar color="default"  class="title font-weight-bold  elevation-0">
         Busqueda de Juramento
        </v-toolbar>
        <v-card-text>
          <v-alert type="info" color="primary lighten-2" :value="true" outline class="pa-3">
            Verifica la fecha de tu Juramento
          </v-alert>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-text-field
              label="Numero de documento"
              prepend-icon="search"
              v-model="numeroDocumento"
              hint="No es necesario la expedicion"
              persistent-hint
              :rules="numeroRules"
              class="mt-3 px-3"
            ></v-text-field>
            <v-dialog
              ref="dialog"
              v-model="modal"
              :return-value.sync="fechaNacimiento"
              persistent
              lazy
              full-width
              width="290px"
            >
              <v-text-field
                slot="activator"
                class="px-3"
                v-model="computedDateFormatted"
                :rules="fechaRules"
                label="Fecha Nacimiento"
                prepend-icon="event"
                readonly
                hint="DD/MM/YYYY formato"
              ></v-text-field>
              <v-date-picker
                ref="picker"
                v-model="fechaNacimiento"
                scrollable
                locale="es"
                :max="new Date().toISOString().substr(0, 10)"
                min="1950-01-01"
              >
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="modal = false">Cancelar</v-btn>
                <v-btn flat color="primary" @click="$refs.dialog.save(fechaNacimiento)">OK</v-btn>
              </v-date-picker>
            </v-dialog>
          </v-form>
          <v-layout>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click.prevent="buscarJuramento()" :loading="loading">
              <v-icon>search</v-icon>Consultar
              <span slot="loader" dark>
                <v-progress-circular size="20" indeterminate color="white"></v-progress-circular>
              </span>
            </v-btn>
          </v-layout>
        </v-card-text>
        <v-card-text>
          <v-layout row wrap v-if="noData">
            <v-alert
              class="flex lg12"
              type="error"
              :value="true"
            >No se encuentra un registro con los parametros de la busqueda</v-alert>
          </v-layout>
          <v-layout row wrap v-if="noJura">
            <v-alert
              class="flex lg12"
              type="warning"
              :value="true"
            >El Registro No Cuenta con informacion del Juramento</v-alert>
          </v-layout>
          <v-layout row wrap v-if="!noJura && resultado">
            <v-flex lg5 xs4>Nombre Abogado:</v-flex>
            <v-flex lg7 xs6 class="text-xs-left">{{nombreCompleto(resultado)}}</v-flex>
            <v-flex lg5 xs4>Fecha Juramento:</v-flex>
            <v-flex lg7 xs6 class="text-xs-left">{{formatDateJuramento(resultado.fechaHora)}}</v-flex>
            <v-flex lg5 xs4>Departamento Juramento:</v-flex>
            <v-flex lg7 xs6 class="text-xs-left">{{resultado.departamento}}</v-flex>
            <v-flex lg5 xs4>Lugar Juramento:</v-flex>
            <v-flex lg7 xs6 class="text-xs-left">{{resultado.lugarJuramento}}</v-flex>
              <v-flex lg5 xs4>Hora Juramento:</v-flex>
            <v-flex lg7 xs6 class="text-xs-left">{{resultado.hora}}</v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
  <Galeria :dialog="dialogFotos" @cerrarGaleria="dialogFotos=false" :juramentos="juramentoSeleccionado"/>
  </div>
</template>
<script>
import Registro from "@/components/Juramento/RegistroJuramento"
import Galeria from "@/components/Juramento/GaleriaFotos"
export default {
  components:{ Registro,Galeria},
  data() {
    return {
      search: null,
      dialogLista:false,
      dialogFotos:false,
      loading: false,
      juramentoSeleccionado:[],
      resp: false,
      headers: [
        {
          text: "Lista",
          aligin: "left",
          sortable: false
        },
        {
          text: "Departamento",
          aligin: "left",
          sortable: false,
          value: "nombre"
        },
        {
          text: "Lugar Evento",
          aligin: "left",
          sortable: false,
          value: "lugarJuramento"
        },
        {
          text: "Fecha Entrega Credenciales",
          aligin: "left",
          sortable: false,
          value: "nombre"
        },
        {
          text: "Cantidad",
          aligin: "left",
          sortable: false,
          value: "cantidad"
        }
      ],
      pagination: {
        rowsPerPage: -1
      },
      numeroDocumento: "",
      fechaNacimiento: "",
      modal: false,
      fechaRules: [
        v => !!v || "La fecha de Nacimento es requerida",
        v => (v && v.length >= 6) || "EL formato no es correcto"
      ],
      numeroRules: [
        v => !!v || "El numero de documento es requerido",
        v => (v && v.length >= 6) || "EL formato no es correcto"
      ],
      resultado: null,
      valid: true,
      noJura: false,
      noData: false,
      isLoading: false
    };
  },
  computed: {
    computedDateFormatted() {
      return this.formatDate(this.fechaNacimiento);
    },
    url() {
      return this.$docUrl;
    },
    desserts() {
      return this.$store.state.juramentos;
    }
  },
  watch: {
    modal(value) {
      value && this.$nextTick(() => (this.$refs.picker.activePicker = "YEAR"));
    }
  },
  methods: {
    buscarJuramento() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        this.noJura = false;
        this.noData = false;
        this.resultado = null;
        this.$http
          .get(`${this.$apiUrl}publico/juramento`, {
            params: {
              fechaNacimiento: this.fechaNacimiento,
              numeroDocumento: this.numeroDocumento
            }
          })
          .then(response => {
            this.loading = false;
            this.resultado = response.data.data;
            if (
              this.resultado.departamento == null &&
              this.resultado.lugarJuramento == null
            ) {
              this.$store.commit('setErrorColor','error')
              this.$store.commit(
                "setError",
                "Todavia no se encuentra informacion del Juramento"
              );
              this.noJura = true;
            }
          })
          .catch(error => {
            this.loading = false;
            this.resultado = false;
            if (error.response.status == 404) {
              this.$store.commit('setErrorColor','error')
              this.$store.commit(
                "setError",
                "Error en la peticion al servidor"
              );
            }
            if (error.response.status == 400) {
              this.$store.commit('setErrorColor','error')
              this.$store.commit(
                "setError",
                "El numero de Documento no se encuentra Registrado"
              );

              this.noData = true;
            }
            if (error.response.status == 500) {
              this.$store.commit('setErrorColor','error')
              this.$store.commit(
                "setError",
                "Formato de parametros incorrectos"
              );
            }
          });
      }
    },
      mostrarLista(){
        this.dialogLista=true;
      },
    pdfJuramento(id) {
      this.isLoading = true;
      this.$http
        .get(`${this.$apiUrl}publico/juramento/${id}`)
        .then(response => {
          let fileType = "application/pdf";
          let name = `${response.data.data.titulo}.pdf`;
          let a = document.createElement("a");
          a.download = name;
          a.href = window.URL.createObjectURL(
            this.b64toBlob(response.data.data.pdf, "application/pdf")
          );
          window.open(a.href);
          this.isLoading = false;
          //a.dataset.downloadurl = [fileType, a.download, a.href].join(":");
          a.style.display = "none";
          document.body.appendChild(a);
          //a.click();
          document.body.removeChild(a);
          setTimeout(() => {
            URL.revokeObjectURL(a.href);
          }, 1500);
        })
        .catch(error => {
          this.isLoading = false;
        });
    },
    b64toBlob(b64Data, contentType, sliceSize) {
      contentType = contentType || "";
      sliceSize = sliceSize || 512;
      let byteCharacters = atob(b64Data);
      let byteArrays = [];
      for (
        let offset = 0;
        offset < byteCharacters.length;
        offset += sliceSize
      ) {
        let slice = byteCharacters.slice(offset, offset + sliceSize);
        let byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }
        let byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }
      let blob = new Blob(byteArrays, { type: contentType });
      return blob;
    },
    formatDate(date) {
      if (!date) return null;
      const [dates, hours] = date.split(" ");
      if (date.indexOf("-") > 0) {
        const [year, month, day] = dates.split("-");
        return `${day}/${month}/${year}`;
      }
      return date;
    },
    formatDateJuramento(date) {
      if (!date) return null;
      const [dates, hours] = date.split(" ");
      if (date.indexOf("-") > 0) {
        const [year, month, day] = dates.split("-");
        return `${day}/${month}/${year}`;
      }
      return date;
    },
    nombreCompleto(data) {
      return (
        data.nombres + " " + data.primerApellido + " " + data.segundoApellido
      );
    },
  verFotosJuramento(data){
    this.juramentoSeleccionado=[data];
    this.dialogFotos=true;
  }
  },
  mounted: function() {
    if (this.$vuetify.breakpoint.width > 960) {
      this.$vuetify.goTo(60);
    } else {
      this.$vuetify.goTo(0);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Juramento/Juramento.vue